const checkStatus = async ({
  client,
  endpoint,
  setRunning,
  setError,
  onSuccess,
  nextStep,
  pollingLabel,
}) => {
  try {
    const res = await client.get(endpoint);
    const status = res.data.status;

    if (status === 'in_progress') {
      console.log(
        `${pollingLabel} still in progress, retrying in 20 seconds...`
      );
      setTimeout(
        () =>
          checkStatus({
            client,
            endpoint,
            setRunning,
            setError,
            onSuccess,
            nextStep,
            pollingLabel,
          }),
        20 * 1000
      ); // Retry after 20 seconds
    } else if (status === 'error') {
      setRunning(false);
      setError(
        `An error occurred during ${pollingLabel.toLowerCase()}. Please try again later.`
      );
    } else if (status === 'success') {
      setRunning(false);
      onSuccess?.();
      if (nextStep) nextStep();
    } else {
      setRunning(false);
      setError(`${pollingLabel} status unknown or not found.`);
    }
  } catch (err) {
    console.error(`${pollingLabel} status check failed:`, err);
    setRunning(false);
    setError(`Failed to check ${pollingLabel} status.`);
  }
};

export default checkStatus;
